exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vendor-settings[data-v-733cae22]{position:absolute;top:1rem;font-size:1.4rem;right:1rem;display:-webkit-box;display:-ms-flexbox;display:flex;cursor:pointer}.vendor-settings[data-v-733cae22]:hover{color:#0e4b88}.vendor-settings span[data-v-733cae22]{font-size:.8rem;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;height:1rem;padding-top:.2rem;padding-left:.2rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-733cae22","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/vendors/VendorDetails.vue
// module id = e6BE
// module chunks = 0 1